module.exports = __webpack_public_path__ + "img/goo.gl.png";